module.exports = __webpack_public_path__ + "img/no-results.dc2a5c6c.svg";